/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
import React, { Suspense, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useRoutes } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Themeroutes from './routes/Router';
import Loader from './layouts/loader/Loader';
import Login from './views/login/Login';
import FullLayout from './layouts/FullLayout';
import McpLogin from './views/mcpLogin/McpLogin';
import { AuthContext } from './context/authContext';
import { getItem, setItem, STORAGE_KEYS } from './services/storage';
import { MCP_LOGIN_PATH } from './helpers/constants';
import { sesionCaducada, cerrarSesionCaducada } from './services/http/sesionCaducada';
import 'react-toastify/dist/ReactToastify.css';

// Aplicar tema guardado antes del primer render
if (localStorage.getItem('ced_admin_theme') === 'new') {
  document.body.classList.add('theme-new');
}

const ToastWrapperMessage = ({ url = '', errorMessage = '' }) => {
  return (
    <div className="flex flex-col gap-2">
      <div style={{ fontSize: '12px', fontWeight: 'bold' }}>{url}</div>
      <div>{errorMessage}</div>
    </div>
  );
};

const App = () => {
  const { logoutGoogle, loadingUserOU, loadingUser } = useContext(AuthContext);
  const routing = useRoutes(Themeroutes);
  const { pathname } = useLocation();
  const userSession = getItem(STORAGE_KEYS.USER);
  const [isVerified, setIsVerified] = useState(1);
  const [check, setCheck] = useState(0);

  let render = null;

  const handleCatchError = (event) => {
    const errorMessage = event.detail.messageError || 'Algo ha salido mal!';
    const url = event.detail.url || '';

    toast.error(<ToastWrapperMessage url={url} errorMessage={errorMessage} />, {
      position: 'bottom-right',
      autoClose: 3000,
      // Una sola notificación: si caen varias peticiones a la vez no se apilan.
      toastId: 'general-error',
    });
  };

  useEffect(() => {
    document.addEventListener('generalerror', handleCatchError);

    return () => {
      document.removeEventListener('generalerror', handleCatchError);
    };
  }, []);

  // Con la pestaña abierta durante horas el token caduca: se comprueba cada minuto
  // y al volver a la pestaña, para pedir login antes de que falle una recarga de datos.
  useEffect(() => {
    const comprobar = () => {
      if (sesionCaducada()) cerrarSesionCaducada();
    };
    const intervalo = setInterval(comprobar, 60 * 1000);
    document.addEventListener('visibilitychange', comprobar);
    return () => {
      clearInterval(intervalo);
      document.removeEventListener('visibilitychange', comprobar);
    };
  }, []);

  const onLoad = (verified) => {
    // Guardamos la URL a acceder en caso de requerir un login antes
    setItem(STORAGE_KEYS.LAST_PATH, window.location.pathname);

    if (getItem(STORAGE_KEYS.USER) === null) {
      if (sessionStorage.getItem('apiError') !== null) {
        render = <Login sesionExpired="true" />;
        sessionStorage.removeItem('apiError');
      } else if (check === 0) {
        render = <Login />;
      } else if (check === 1) {
        render = <Login sesionExpired="true" />;
      }
    } else if (userSession !== null) {
      if (verified === 0) {
        logoutGoogle();
        render = <Login sesionExpired="true" />;
        setIsVerified(1);
        setCheck(1);
      } else {
        render = <FullLayout>{routing}</FullLayout>;
      }
    }

    return render;
  };

  return (
    //<>{routing}</>
    <Suspense fallback={<Loader />}>
      <div className="ltr" dir="ltr">
        {/* /mcp-login va fuera de la puerta de sesión y de FullLayout, antes del loader
            (loginGoogle lo activaría y desmontaría la página) y sin escribir LAST_PATH. */}
        {pathname === MCP_LOGIN_PATH ? (
          <McpLogin />
        ) : loadingUserOU || loadingUser ? (
          <div
            style={{
              display: 'flex',
              height: '100vh',
              width: '100vw',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Loader sizeScale={2} />
          </div>
        ) : (
          onLoad(isVerified)
        )}
      </div>
      <ToastContainer />
    </Suspense>
  );
};

ToastWrapperMessage.propTypes = {
  url: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default App;
